module.exports = __webpack_public_path__ + "img/square_logo.832a0125.png";